export const REPORT_RESOURCE_PATHS: {
    [key: string]:
        | {
              path: string
              title: string
              test: string
              type: string
          }
        | undefined
} = {
    topbuyers: {
        path: '/public/spark_embedded/topbuyersods',
        title: 'Top Buyers',
        test: 'TOP BUYERS',
        type: 'auction',
    },
    topdealers: {
        path: '/public/spark_embedded/topdealersods',
        title: 'Top Sellers',
        test: 'TOP SELLERS',
        type: 'auction',
    },
    saleresultsbylanelot: {
        path: '/public/spark_embedded/saleresultsbylanelotods',
        title: 'Sales By Lane',
        test: 'SALES BY LANE',
        type: 'auction',
    },
    nosaleods: {
        path: '/public/spark_embedded/nosaleods',
        title: 'No Sale',
        test: 'NO SALE',
        type: 'auction',
    },
    dealerlist: {
        path: '/public/spark_embedded/dealerlistods',
        title: 'Dealer List',
        test: 'DEALER LIST',
        type: 'auction',
    },
    sellersummary: {
        path: '/public/spark_embedded/sparksellersummary',
        title: 'Seller Summary',
        test: 'SELLER SUMMARY',
        type: 'account',
    },
    sellerdetail: {
        path: '/public/spark_embedded/sparksellerdetail',
        title: 'Seller Detail',
        test: 'SELLER DETAIL',
        type: 'account',
    },
    buyerdetail: {
        path: '/public/spark_embedded/sparkbuyerdetail',
        title: 'Buyer Detail',
        test: 'BUYER DETAIL',
        type: 'account',
    },
    buyersummary: {
        path: '/public/spark_embedded/sparkbuyersummary',
        title: 'Buyer Summary',
        test: 'BUYER SUMMARY',
        type: 'account',
    },
    blockworksheetwithnotes: {
        path: '/public/spark_embedded/sparkblockwithnotes',
        title: 'Block Worksheet With Consignor Notes',
        test: 'BLOCK WORKSHEET WITH CONSIGNOR NOTES',
        type: 'account',
    },
    salesByWeek: {
        path: '/public/spark_embedded/18monthsaleschart',
        title: 'Sales By Week',
        test: 'Sales by week',
        type: 'full',
    },
    salesByWeekAccount: {
        path: '/public/spark_embedded/18monthsaleschartdealer',
        title: 'Sales By Week',
        test: 'Sales by week',
        type: 'fullDealer',
    },
    salesWeekDetail: {
        path: '/public/spark_embedded/salesweekdetail',
        title: 'Sales Week Detail',
        test: 'Sales Week Detail',
        type: 'detail',
    },
}
